import PropTypes from 'prop-types'
import classNames from 'classnames'
import BaseBreadcrumb from '../../breadcrumb'

const Breadcrumb = ({ article, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'pb-20'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <BaseBreadcrumb
        items={[
          {
            text: 'Cursos',
            href: '/blog/'
          },
          {
            text: article.title,
            href: `/blog/${article.id}/${article.meta.slug}`
          }
        ]} />
    </div>
  </section>
}

Breadcrumb.propTypes = {
  article: PropTypes.object
}

export default Breadcrumb
